import { Directive } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[isProsightEmailValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: IsProsightEmailValidatorDirective, multi: true}]
})
export class IsProsightEmailValidatorDirective implements Validator{

  constructor() { }

  validate(control: AbstractControl) : ValidationErrors | null{
    if(control.value && (control.value.includes("@coactionspecialty.com") || control.value.includes("@coactionbrokerage.com") || control.value.includes("@prosightspecialty.com") || control.value.includes("@prosightbrokerage.com"))){
      return {isProSightEmail: {valid : false}};
    }else{
      return null;
    }
  }
}
